//
export default {
  LOGIN: '/jury/professor/login',                              // 登录

  LOGOUT: '/jury/professor/logout',                              // 登录

  CHANGE_PASSWORD: '/jury/professor/changPwd',                 // 修改密码

  RESET_PASSWORD: '/jury/professor/resetPwd',                 // 修改密码

  GET_SMSCODE: '/jury/professor/getSmsCode',                   // 获取教练登录验证码

  VALIDATE: '/jury/professor/validate',                         // 验证教练登录验证码

  CONTEST_SEASONS: '/jury/professor/contest/seasons'                         // 评委拥有的活动/活动季接口
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/user.js